// extracted by mini-css-extract-plugin
module.exports = {"money":"styles_money__qLwqX","animate":"styles_animate__saXCW"};